/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Casmanagement_Visibility1Inputs */

const en_settings_casmanagement_visibility1 = /** @type {(inputs: Settings_Casmanagement_Visibility1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage CAS`)
};

/**
* | output |
* | --- |
* | "Manage CAS" |
*
* @param {Settings_Casmanagement_Visibility1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_casmanagement_visibility1 = /** @type {((inputs?: Settings_Casmanagement_Visibility1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Casmanagement_Visibility1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_casmanagement_visibility1(inputs)
});
export { settings_casmanagement_visibility1 as "settings_casManagement_visibility" }